import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components'
import { Globe } from 'lucide-react'
import React from 'react'
import { allTimezones } from '../constants'
import { useTimezoneSelect } from '../hooks/use-timezone-select'

interface Props {
  value: string
  onChange: (timezone: string) => void
  className?: string
}

export const TimezoneSelector: React.FC<Props> = ({ value, onChange, className }) => {
  const { options, parseTimezone } = useTimezoneSelect({ timezones: allTimezones })

  // `allTimezones` is a curated list (one IANA name per offset bucket —
  // `America/Detroit` for Eastern, `America/Boise` for Mountain, etc.). The
  // browser's `Intl` TZ is the canonical name (`America/New_York`) and
  // rarely matches a list key verbatim, so Radix's Select would render the
  // placeholder. Normalize through the fuzzy parser so the trigger shows
  // the equivalent bucket.
  const resolvedValue = value ? (parseTimezone(value)?.value ?? '') : ''

  return (
    <div className={`flex items-center gap-2 text-paper-faint ${className ?? ''}`}>
      <Globe size={16} />
      <Select onValueChange={e => onChange(parseTimezone(e).value)} value={resolvedValue}>
        <SelectTrigger variant="dark" className="min-w-0 flex-1">
          <SelectValue placeholder="Select a timezone" />
        </SelectTrigger>
        <SelectContent variant="dark">
          {options.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
